/* =========================================================================
   Penny Premium 3D — sticky-atc.js
   Shows the sticky add-to-cart bar once the buy-box ATC button
   ([data-atc-anchor]) scrolls above the viewport; hides it again near the
   footer and while the cart drawer is open. Transform-only — zero layout
   shift. The bar's button submits the main product form via form=.
   ========================================================================= */

const bar = document.querySelector('[data-sticky-atc]');
const anchor = document.querySelector('[data-atc-anchor]');

if (bar && anchor) {
  let pastAnchor = false;
  let nearFooter = false;
  let drawerOpen = false;

  const render = () => {
    bar.classList.toggle('is-visible', pastAnchor && !nearFooter && !drawerOpen);
  };

  new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      pastAnchor = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      render();
    });
  }).observe(anchor);

  const footer = document.querySelector('.footer');
  if (footer) {
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        nearFooter = entry.isIntersecting;
        render();
      });
    }).observe(footer);
  }

  window.penny?.on('cart-drawer:open', () => {
    drawerOpen = true;
    render();
  });

  window.penny?.on('cart-drawer:close', () => {
    drawerOpen = false;
    render();
  });
}
